/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Global asistan mesajlarında API'den gelen zaman damgasını korur ve
 * yeni istemci mesajları için tek biçimli ISO zaman damgası üretir.
 */

export function normalizeAssistantMessageTimestamp(value: unknown): string | undefined {
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value.toISOString() : undefined;
  }

  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date.toISOString() : undefined;
  }

  if (typeof value !== 'string') return undefined;
  const normalized = value.trim();
  if (!normalized) return undefined;
  return Number.isFinite(new Date(normalized).getTime()) ? normalized : undefined;
}

export function createAssistantMessageTimestamp(now: Date | number = Date.now()): string {
  const date = now instanceof Date ? now : new Date(now);
  if (!Number.isFinite(date.getTime())) {
    throw new RangeError('Geçerli mesaj zamanı zorunludur');
  }
  return date.toISOString();
}

function readTextField(source: unknown, key: string): string {
  if (!source || typeof source !== 'object') return '';
  const value = (source as Record<string, unknown>)[key];
  return typeof value === 'string' ? value.trim() : '';
}

function hasSuccessfulSupportTicketResult(source: unknown): boolean {
  if (!source || typeof source !== 'object') return false;
  const record = source as Record<string, unknown>;
  return record.created === true || record.alreadyExists === true;
}

export function buildSupportTicketTrackingMessage(
  baseMessage: string,
  result: unknown,
  language?: string,
): string {
  const message = String(baseMessage ?? '').trim();
  if (!hasSuccessfulSupportTicketResult(result)) return message;

  const isSaasSupport = readTextField(result, 'supportTarget') === 'QUBEPRO_SAAS';
  const ticketNumber = readTextField(result, 'ticketNumber');
  const ticketUrl = readTextField(result, 'ticketUrl');
  const lowerMessage = message.toLocaleLowerCase('tr-TR');
  if (
    lowerMessage.includes(isSaasSupport ? 'qubepro taleplerim' : 'destek talepleri')
    && lowerMessage.includes('cevap')
    && (!ticketNumber || message.includes(ticketNumber))
  ) {
    return message;
  }

  const languageCode = String(language ?? '').toLowerCase().split('-')[0];
  const isTr = languageCode !== 'en';
  const trackingText = isTr
    ? [
        ticketNumber ? `Kayıt no: ${ticketNumber}` : '',
        isSaasSupport
          ? 'Takip ve cevap: Support > QubePro Taleplerim ekranında kaydı açıp durumunu izleyebilir, Müşteriye açık konuşma sekmesinden aynı kayıt üzerinden yanıt yazabilirsiniz.'
          : 'Takip ve cevap: Support > Destek Talepleri ekranında kaydı açıp durumunu izleyebilir, Konuşma sekmesinden aynı kayıt üzerinden yanıt yazabilirsiniz.',
        ticketUrl ? `Bağlantı: ${ticketUrl}` : '',
      ]
    : [
        ticketNumber ? `Ticket number: ${ticketNumber}` : '',
        isSaasSupport
          ? 'Track and reply: open the ticket from Support > My QubePro Requests, follow the status, and reply from the Customer-facing conversation tab on the same ticket.'
          : 'Track and reply: open the ticket from Support > Support Tickets, follow the status, and reply from the Conversation tab on the same ticket.',
        ticketUrl ? `Link: ${ticketUrl}` : '',
      ];

  return [message, trackingText.filter(Boolean).join('\n')].filter(Boolean).join('\n\n');
}
